import React from 'react';
import { render } from 'react-dom';

import { configureStore } from '@mssgme/store';
import { AuthApp } from '@mssgme/auth';
import { analytics, GoogleTagManagerProvider } from '@mssgme/analytics';

analytics.registerProvider(new GoogleTagManagerProvider({ skipInitialization: true }));
analytics.initialize();

const store = configureStore();

render(<AuthApp store={store} />, document.getElementById('root'));
